<template>
    <button
        :type="type"
        class="btn"
        :class="[btnClass, { 'btn-counter': counter }]"
        :disabled="disabled || loadingStatus === 'loading'"
        :data-counter="counter"
        @click="$emit('click')"
    >
        <button-spinner
            v-if="icon && loadingStatus === 'loading'"
            class="btn__icon"
            status="loading"
        />
        <a-icon
            v-else-if="icon"
            class="btn__icon"
            :icon="icon"
        />

        <span
            v-if="text"
            v-text="text"
            class="d-lg-inline"
            :class="{ 'd-none': mobileText }"
        />
        <span v-if="mobileText" v-text="mobileText" class="d-lg-none" />

        <slot />
    </button>
</template>

<script>
export default {
    props: {
        btnClass: {
            type: String,
            default: 'btn-primary'
        },
        text: {
            type: String,
            required: false
        },
        mobileText: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'submit'
        },
        onClick: {
            type: Function,
            default: () => {}
        },
        counter: {
            type: Number,
            default: null
        },
        loadingStatus: {
            type: String
        }
    }
}
</script>
